// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"ba67143c","579":"c26d4d85"}[chunkId] + ".chunk.js";
};